import { AppLink } from '@/global/components/AppLink'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'
import { buildRouteUrl } from '@/modules/accredited-establishments/functions'
import { RouteDestination } from '@/modules/accredited-establishments/types/RouteDestination'

const LABEL = 'Como chegar'

interface RouteLinkProps {
  destination: RouteDestination
  className?: string
}

/*
 * Link unico de rota das tres superficies. O contrato de analytics e a
 * exigencia de `withoutUtms` vivem aqui: duplicados por superficie, uma copia
 * mudaria sem a outra e a URL do Maps sairia corrompida numa delas.
 */
const RouteLink = ({ destination, className }: RouteLinkProps) => (
  /*
   * `withoutUtms` e obrigatorio: sem ele o AppLink anexa os UTM da pagina ao
   * destino e o Google Maps recebe uma URL corrompida.
   *
   * O `aria-label` carrega o endereco porque o texto visivel se repete em cada
   * bloco: sem ele o leitor de tela anuncia varios links identicos.
   */
  <AppLink
    className={className}
    as='button'
    variant='secondary'
    size='small'
    icon='icSend1'
    iconPosition='leading'
    href={buildRouteUrl(destination)}
    target='_blank'
    withoutUtms
    ariaLabel={`${LABEL} para ${destination.address}`}
    event={{
      eventName: EventName.BUTTON_CLICKED,
      buttonType: ButtonType.NEW_PAGE,
      buttonName: LABEL
    }}
  >
    {LABEL}
  </AppLink>
)

export { RouteLink }
export type { RouteLinkProps }
